<div id="global-borrower-tabs" *ngIf="(tabs$ | async) as tabs" class="tw-hidden md:tw-h-12 md:tw-px-4 md:tw-border-b md:tw-border-gray-300 md:tw-block md:tw-flex md:tw-items-center md:tw-justify-between">
  <div class="tw-flex-1 tw-overflow-hidden">
    <nav
      mat-tab-nav-bar
      mat-stretch-tabs="false"
      mat-align-tabs="start"
      *ngIf="tabs.length > 0"
      class="global-borrower-tabs-smart x-mat-tabs-divide"
      [tabPanel]="navPanel"
      borderless>
      <a mat-tab-link *ngFor="let tab of tabs"
        [routerLink]="['/borrower/' + tab.tabId]"
        [active]="(activeTab$ | async)?.tabId == tab.tabId"
         matTooltip="{{tab.name?.length > 20 ? tab.name : ''}}"
        class="tw-flex tw-items-center x-tab tw-justify-between">
        <span class="tw-truncate tw-block tw-flex-1 tw-w-[164px] tw-overflow-hidden">{{ tab.name }}</span>
        <mat-icon class="tw-ml-1 tw-text-gray-400 x-icon" (click)="handleCloseTab(tab, $event)">close</mat-icon>
      </a>
    </nav>
  </div>
  <div class="tw-flex tw-gap-2 tw-items-center tw-text-sky-600">
    <button *ngIf="tabs.length > 1" mat-stroked-button (click)="openConfirmCloseDialog()">
      Close All Tabs
    </button>
    <app-add-new-lead-button></app-add-new-lead-button>
  </div>
</div>

<!-- required for mat-tab-nav-bar -->
<mat-tab-nav-panel #navPanel></mat-tab-nav-panel>
